import React from 'react'
import LogoContainer from '../components/LogoContainer'

const GizlilikPolitikasi = () => {
    return (
        <div className=' bg-white min-h-screen pb-20'>



            <div className='grid grid-cols-14 md:grid-cols-8'>

                <div className='col-start-2 col-span-12  md:col-start-2 md:col-span-6  '>
                    <div >
                        <h1 className='text-35 font-medium mb-8'>GİZLİLİK POLİTİKASI</h1>


                        <div>
                        <p className='text-20 mb-8'>
                            Gökdelen İskele-Kalıp Sanayi ve Ticaret A.Ş. olarak, web sitemizi ziyaret eden
                            kullanıcılarımızın gizliliğini korumayı taahhüt ediyoruz. Bu Gizlilik Politikası,{" "}
                            <a href="https://www.gokdelen.com.tr/" target="_blank" rel="noopener noreferrer">
                                https://www.gokdelen.com.tr/
                            </a>{" "}
                            adresli sitemizi ziyaret eden kullanıcılarımızın hangi kişisel verilerini
                            topladığımızı, bu verileri nasıl işlediğimizi ve koruduğumuzu açıklamaktadır.
                        </p>
                        </div>


                        <div>
                        <h2 className='text-25 mb-4 font-medium'>1. Toplanan Kişisel Veriler ve Toplanma Yöntemleri</h2>
                        <p className='mb-4'>Web sitemizi ziyaret ettiğinizde aşağıdaki kişisel verileriniz toplanabilir:</p>
                        <ul className='space-y-2 mb-8'>
                            <li >
                                <strong>İletişim Bilgileri:</strong> Adınız, soyadınız, e-posta adresiniz,
                                telefon numaranız ve posta adresiniz gibi bilgiler, iletişim formları veya
                                e-bülten abonelikleri aracılığıyla tarafınızdan sağlanabilir.
                            </li>
                            <li>
                                <strong>Teknik Veriler:</strong> IP adresiniz, tarayıcı türünüz, işletim
                                sisteminiz, ziyaret ettiğiniz sayfalar ve ziyaret tarih/saat bilgileri gibi
                                veriler, çerezler ve benzeri teknolojiler aracılığıyla otomatik olarak
                                toplanabilir.
                            </li>
                        </ul>
                        </div>


                        <div>
                        <h2 className='text-25 mb-4 font-medium'>2. Kişisel Verilerin İşlenme Amaçları</h2>
                        <p className='mb-4'>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenebilir:</p>
                        <ul className='space-y-4 mb-8'>
                            <li>
                                <strong>Hizmet Sunumu:</strong> Talep ettiğiniz ürün ve hizmetleri sunmak,
                                siparişlerinizi işlemek ve teslim etmek.
                            </li>
                            <li>
                                <strong>İletişim:</strong> Sorularınızı yanıtlamak, destek taleplerinizi
                                karşılamak ve güncellemeler hakkında sizi bilgilendirmek.
                            </li>
                            <li>
                                <strong>Pazarlama:</strong> Ürün ve hizmetlerimizle ilgili bilgilendirme yapmak,
                                kampanyalar ve promosyonlar hakkında sizi haberdar etmek (açık rızanızın
                                bulunması halinde).
                            </li>
                            <li>
                                <strong>Analiz ve İyileştirme:</strong> Web sitemizin performansını analiz
                                etmek, kullanıcı deneyimini geliştirmek ve hizmet kalitemizi artırmak.
                            </li>
                        </ul>
                        </div>




                        <div>
                        <h2 className='text-25 mb-4 font-medium'>3. Kişisel Verilerin Aktarılması</h2>
                        <p className='mb-8'>
                            Kişisel verileriniz, yasal yükümlülükler veya hizmetlerin ifası için gerekli
                            olmadıkça üçüncü şahıslarla paylaşılmayacaktır. Gerekli durumlarda, veri aktarımı
                            Kanun'un 8. ve 9. maddelerine uygun olarak gerçekleştirilecektir.
                        </p>

                        <h2 className='text-25 mb-4 font-medium'>4. Kişisel Verilerin Saklanması ve Korunması</h2>
                        <p className='mb-8'>
                            Kişisel verileriniz, işlendikleri amaç için gerekli olan süre boyunca saklanacak
                            ve yetkisiz erişim, kayıp veya ifşaya karşı uygun teknik ve idari tedbirlerle
                            korunacaktır. Verilerinizin güvenliği için SSL şifreleme ve erişim kontrol
                            mekanizmaları gibi önlemler uygulanmaktadır.
                        </p>
                        </div>


                        <div>
                        <h2 className='text-25 mb-4 font-medium'>5. Kişisel Veri Sahibinin Hakları</h2>
                        <p>Kanun'un 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:</p>
                        <ul className='mb-8'>
                            <li><span className='mr-2'>●</span>Kişisel verilerinizin işlenip işlenmediğini öğrenme.</li>
                            <li><span className='mr-2'>●</span>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme.</li>
                            <li><span className='mr-2'>●</span>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme.</li>
                            <li><span className='mr-2'>●</span>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme.</li>
                            <li><span className='mr-2'>●</span>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme.</li>
                            <li><span className='mr-2'>●</span>Kanun'un 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme.</li>
                            <li><span className='mr-2'>●</span>Yukarıdaki taleplerinizin, kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme.</li>
                            <li><span className='mr-2'>●</span>İşlenen verilerin münhasıran otomatik sistemler aracılığıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme.</li>
                            <li><span className='mr-2'>●</span>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.</li>
                        </ul>
                        </div>



                        <div>
                        <h2 className='text-25 mb-4 font-medium'>6. İletişim</h2>
                        <p className='mb-4'>
                            Kişisel verilerinizle ilgili taleplerinizi ve sorularınızı aşağıdaki iletişim
                            bilgileri aracılığıyla bize iletebilirsiniz:
                        </p>
                        <p className='mb-2'>
                            <strong>Adres:</strong> Organize Sanayi Bölgesi 2. Kısım, İbrahim Çallı Cd. No.5,
                            20065 - DENİZLİ/TÜRKİYE
                        </p>
                        <p className='mb-2'>
                            <strong>Telefon:</strong>{" "}
                            <a href="tel:+902582691095">+90 (258) 269 10 95</a>
                        </p>
                        <p className='mb-2'>
                            <strong>E-posta:</strong>{" "}
                            <a href="mailto:info@gokdelen.com.tr">info@gokdelen.com.tr</a>
                        </p>

                        <p>
                            Bu Gizlilik Politikası, <strong>21 Şubat 2025</strong> tarihinde güncellenmiştir.
                            Gelecekte yapılacak değişiklikler web sitemiz üzerinden duyurulacaktır.
                        </p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default GizlilikPolitikasi